'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var polished = require('polished');

var _breakpointMinWidths, _gridContainerMaxWidt;
var WIDTH_XS = 'xs';
var WIDTH_SM = 'sm';
var WIDTH_MD = 'md';
var WIDTH_LG = 'lg';
var WIDTH_XL = 'xl';
var breakpointMinWidths = (_breakpointMinWidths = {}, _defineProperty(_breakpointMinWidths, WIDTH_XS, polished.rem('0px')), _defineProperty(_breakpointMinWidths, WIDTH_SM, polished.rem('660px')), _defineProperty(_breakpointMinWidths, WIDTH_MD, polished.rem('768px')), _defineProperty(_breakpointMinWidths, WIDTH_LG, polished.rem('960px')), _defineProperty(_breakpointMinWidths, WIDTH_XL, polished.rem('1248px')), _breakpointMinWidths);
var gridContainerMaxWidths = (_gridContainerMaxWidt = {}, _defineProperty(_gridContainerMaxWidt, WIDTH_XS, 'auto'), _defineProperty(_gridContainerMaxWidt, WIDTH_SM, 'auto'), _defineProperty(_gridContainerMaxWidt, WIDTH_MD, polished.rem('768px')), _defineProperty(_gridContainerMaxWidt, WIDTH_LG, polished.rem('960px')), _defineProperty(_gridContainerMaxWidt, WIDTH_XL, polished.rem('1248px')), _gridContainerMaxWidt);
var columns = 12;
var gutterHalfWidth = polished.rem('8px');

exports.WIDTH_LG = WIDTH_LG;
exports.WIDTH_MD = WIDTH_MD;
exports.WIDTH_SM = WIDTH_SM;
exports.WIDTH_XL = WIDTH_XL;
exports.WIDTH_XS = WIDTH_XS;
exports.breakpointMinWidths = breakpointMinWidths;
exports.columns = columns;
exports.gridContainerMaxWidths = gridContainerMaxWidths;
exports.gutterHalfWidth = gutterHalfWidth;
